import { decodeJWT } from '@moko/utils/src/authTokenValidation';

// Match getFmsToken/getAuthHeader: portal requests use `token`, while other apps
// may retain a different session under `auth.accessToken` on the same origin.
const claims = (): Record<string, unknown> | null => {
  const token = localStorage.getItem('token');
  return token ? decodeJWT(token) : null;
};
export function getPortalTenantId(): number | undefined {
  const value = Number(claims()?.tenantId);
  return Number.isInteger(value) && value > 0 ? value : undefined;
}
